export default "__VITE_ASSET__uK5dbN41__"